var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.deviation)?_c('DeviationPanel',{attrs:{"deviation":_vm.deviation},on:{"delete":_vm.deleteDeviation}}):_vm._e(),_c('DeviationDialog',{on:{"update":_vm.updateDeviation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }